// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","active":"Navbar_active__MLHq1","links":"Navbar_links__s0NVS"};